import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import {
  AMENITIES_SECTION_EDIT,
  AMENITIES_CATEGORY_LIST,
} from '../../../../../constants/AmenityConst';
import {
  RBAC_PERMISSION_LEVEL_FULL_ACCESS,
  RBAC_TYPE_HOTEL_AMENITIES,
} from '../../../../../constants/RoleConsts';
import DetailViewLayout from '../../../../../shared/detail-view-layout/Detail-View-Layout';
import {
  allAmenityCategoriesSelector,
  allAmenitySectionsSelector,
} from '../../../../property/propertySlice';
import './Amenity-Section-view.scss';
import MediaViewer from '../../../../../shared/media-viewer/MediaViewer';
import { EMPTY_PLACEHOLDER } from '../../../../../utils/Constants';

const AmenitySectionView = (props) => {
  const { amenitiesSection, onViewToggle, toggleDrawer, permissions } = props;
  const [selectedSection, setSelectedSection] = useState(amenitiesSection);
  const originalAmenitySections = useSelector(allAmenitySectionsSelector);
  const originalCategories = useSelector(allAmenityCategoriesSelector);
  const [tabValue, setTabValue] = useState(0);

  useEffect(() => {
    const catObj = {
      ...originalAmenitySections?.find((cat) => cat?.id === amenitiesSection?.id),
      customAttributes: amenitiesSection?.customAttributes,
    };
    const catAmenities = originalCategories
      ?.filter((amenity) => amenity?.sectionId === catObj?.id)
      ?.map((c) => c.name);
    catObj['categories'] = catAmenities;

    setSelectedSection(catObj);
  }, [originalAmenitySections, originalCategories, amenitiesSection]);

  const onClickEdit = (event) => {
    toggleDrawer(AMENITIES_SECTION_EDIT, true, selectedSection);
  };

  const retrieveNoOfCategories = (section) => {
    let counter = {};
    let count = 0;
    originalCategories?.forEach((room) =>
      room?.sectionIds?.forEach((item) => {
        item === section?.id && (counter[section?.name] = count += 1);
      }),
    );
    return counter[section?.name] ? counter[section?.name] : 0;
  };

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const retrieveCategories = (section) => {
    let names = [];
    originalCategories?.forEach((item) => {
      item?.sectionIds?.includes(section?.id) && (names = [...names, item?.name]);
    });
    return names?.length > 0 ? names?.join(', ') : EMPTY_PLACEHOLDER;
  };

  const renderScreen = () => {
    return (
      <>
        {tabValue === 0 && (
          <div>
            <div className='row mx-4 mt-4'>
              <div className='col-md-12 mb-4'>
                <span className='page-title-secondary'>Details</span>
              </div>
            </div>
            <div className='row mx-4 mt-4'>
              <div className='col-md-4'>
                <div className='details-label'>Section Name</div>
                <div className='details-value preview-breaks'>{selectedSection?.name}</div>
              </div>
            </div>
            <div className='row mx-4 mt-4'>
              <div className='col-md-4'>
                <div className='details-label'>No of Categories</div>
                <div className='details-value'>{retrieveNoOfCategories(selectedSection)}</div>
              </div>
            </div>
            <div className='row mx-4 mt-4'>
              <div className='col-md-12'>
                <div className='details-label'>Category Name</div>
                <div className='details-value'>{retrieveCategories(selectedSection)}</div>
              </div>
            </div>
            <div className='row mx-4 mt-4'>
              {selectedSection?.customAttributes &&
                selectedSection?.customAttributes?.length > 0 &&
                selectedSection?.customAttributes?.map((item, index) => (
                  <div key={index} className='col-md-6 mb-2'>
                    <div className='details-label'>{item?.key}</div>
                    <div className='details-value'>{item?.value}</div>
                  </div>
                ))}
            </div>
          </div>
        )}
        {tabValue === 1 && (
          <div className='row pt-4 px-3'>
            <MediaViewer
              images={selectedSection.images}
              videos={selectedSection.videos}
              gifs={selectedSection.gifs}
              enabledMediaTabs={['image']}
            />
          </div>
        )}
      </>
    );
  };

  return (
    <>
      {selectedSection && (
        <DetailViewLayout
          onClickEdit={onClickEdit}
          renderScreen={renderScreen}
          tabValue={tabValue}
          handleTabChange={handleTabChange}
          tabList={AMENITIES_CATEGORY_LIST}
          onViewToggle={onViewToggle}
          title={selectedSection.name}
          createdUserId={selectedSection?.createdBy}
          isEditable={permissions[RBAC_TYPE_HOTEL_AMENITIES] === RBAC_PERMISSION_LEVEL_FULL_ACCESS}
        />
      )}
    </>
  );
};

export default AmenitySectionView;
